import { IncomingMessage, ServerResponse } from 'http'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { AFFILIATE_REF_STORAGE_KEY, AFFILIATE_REF_TTL_SECONDS } from 'types/affiliates'

type ServerContext = { req: IncomingMessage; res: ServerResponse }

/** Last click wins: always overwrites and restarts the 30 days. */
export const setAffiliateRef = (slug: string, ctx?: ServerContext) => {
  setCookie(AFFILIATE_REF_STORAGE_KEY, slug, {
    ...ctx,
    maxAge: AFFILIATE_REF_TTL_SECONDS,
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  })
}

export const getAffiliateRef = (): string | undefined => {
  const value = getCookie(AFFILIATE_REF_STORAGE_KEY)
  return typeof value === 'string' && value ? value : undefined
}

export const clearAffiliateRef = () => {
  deleteCookie(AFFILIATE_REF_STORAGE_KEY, { path: '/' })
}
